import { Heart } from "@phosphor-icons/react";
import { useLang } from "@/context/LanguageContext";

export default function Marquee() {
  const { t } = useLang();
  const items = t("marquee");
  return (
    <div className="relative py-6 bg-foreground overflow-hidden -rotate-1 my-8">
      <div className="flex whitespace-nowrap animate-marquee">
        {[...items, ...items].map((it, i) => (
          <span key={i} className="flex items-center gap-4 mx-6 font-display font-semibold text-2xl sm:text-3xl text-background">
            {it}
            <Heart weight="fill" className="text-primary" size={22} />
          </span>
        ))}
      </div>
    </div>
  );
}
